import { render, staticRenderFns } from "./FormGrupoEmpresarial.vue?vue&type=template&id=fb8eb5ce"
import script from "./FormGrupoEmpresarial.vue?vue&type=script&lang=js"
export * from "./FormGrupoEmpresarial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports